import 'core-js/proposals/reflect-metadata';

import { Serializable, jsonProperty } from 'ts-serializable';
import Exam from './Exam';
import Category from './Category'
import Procedure from './Procedure';
import VitalSign from './VitalSign';

class CareLine extends Serializable {

    @jsonProperty(String, null)
    id: string = '';

    @jsonProperty(String, null)
    nome: string = '';

    @jsonProperty(String, null)
    sexo: string = '';

    @jsonProperty(Number, null)
    idadeMinima: number | null = null;
    
    @jsonProperty(Number, null)
    idadeMaxima: number | null = null;

    @jsonProperty(Boolean)
    inativo: boolean = false;

    @jsonProperty([Category])
    categorias: Category[] = []

    @jsonProperty([Exam])
    exames: Exam[] = []

    @jsonProperty([Procedure])
    procedimentos: Procedure[] = []
    
    @jsonProperty([VitalSign])
    sinaisVitais: VitalSign[] = []
}

export default CareLine;